module.exports = __webpack_public_path__ + "public/img/消防监控bg.6d81bd7c.png";